import { render, staticRenderFns } from "./AgreementBar.vue?vue&type=template&id=a64906f4&scoped=true&"
import script from "./AgreementBar.vue?vue&type=script&lang=js&"
export * from "./AgreementBar.vue?vue&type=script&lang=js&"
import style0 from "./AgreementBar.vue?vue&type=style&index=0&id=a64906f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64906f4",
  null
  
)

export default component.exports